import React from 'react'
import { StyledHomeLink, StyledWestLiveIcon } from './TheWestHeaderActions.styled'
import { IconWestLiveProps } from 'component-library/icons/IconWestLive/IconWestLive'

export const WestLiveAction: React.FC<IconWestLiveProps> = ({ showEqualizer }) => {
    return (
        <StyledHomeLink to="/the-west-live" aria-label="The West Live">
            <StyledWestLiveIcon showEqualizer={showEqualizer} />
        </StyledHomeLink>
    )
}
WestLiveAction.displayName = 'WestLiveAction'
